import { EventEmitter, Input, Output, Component } from '@angular/core';
import { TOGGLE_LINK_CONSTANTS } from './toggle-link.constants';
import { CollapsiblePanelEvent } from '../collapsible-panel/collapsible-panel-event.interface';

@Component({
	selector: 'ea-toggle-link',
	templateUrl: './toggle-link.component.html',
	styleUrls: ['./toggle-link.component.scss']
})
export class ToggleLinkComponent {
	@Input() textWhenToggled = TOGGLE_LINK_CONSTANTS.defaultToggledText;
	@Input() textWhenUntoggled = TOGGLE_LINK_CONSTANTS.defaultUnToggledText;
	@Input() name: string;
	@Input() isToggled = false;
	@Output() readonly toggle = new EventEmitter<CollapsiblePanelEvent>();

	toggleClick(): void {
		this.isToggled = !this.isToggled;
		this.toggle.emit({ toggled: this.isToggled });
	}
}
